import { Component, Input, OnInit } from "@angular/core";
import { AlertService } from "src/app/viewer/services/alert.service";

@Component({
  selector: "app-see-alerts",
  templateUrl: "./see-alerts.component.html",
  styleUrls: ["./see-alerts.component.scss"]
})
export class SeeAlertsComponent implements OnInit {
  @Input() highlightTitle = false;
  public loadingPage: boolean;
  public redalerts: any[] = [];
  @Input() unreadalerts: any[];
  public expierdalerts: any[];
  constructor(private alertService: AlertService) {}

  ngOnInit() {
    this.loadingPage = true;
    this.alertService.getreadAlerts().then(res => {
      this.redalerts = res;
      this.loadingPage = false;
    });
    this.alertService.getUnreadAlerts().then(res => {

      this.unreadalerts = res.reverse();
    });
    this.alertService.changeMessage("Hello from Sibling");
  }
  marquerLu(id: number) {
    this.loadingPage = true;
    this.alertService.changeMessage("Hello from Sibling");
    const data: any = {
      closureNote: ""
    };

    this.alertService
      .changeAlertStatus(data, this.unreadalerts[id].id)
      .then(res => {
        this.redalerts.push(this.unreadalerts[id]);
        this.redalerts = [...this.redalerts];
        this.unreadalerts.splice(id, 1);

        this.loadingPage = false;
      });
  }

  deleteAlert(id: number) {
    this.loadingPage = true;

    this.alertService.deleteAlert(this.redalerts[id].id).then(res => {
      this.redalerts.splice(id, 1);

      this.loadingPage = false;
    });
  }

  newMessage() {
    this.alertService.changeMessage("Hello from Sibling");
  }
}
